import { render } from "./Salads.vue?vue&type=template&id=582bedfe&scoped=true"
import script from "./Salads.vue?vue&type=script&lang=js"
export * from "./Salads.vue?vue&type=script&lang=js"

import "./Salads.vue?vue&type=style&index=0&id=582bedfe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582bedfe"]])

export default __exports__